import axios from "axios";
import router from "@/router";
import httpClient from "@/api/config";

import findIndex from 'lodash/findIndex';

const resetDefaultState = () => ({
	sentimentGraphSuggestedMax: 0,
	totalCategoriesGroupSuggestedMax: 0,
	mentionComparisonMetric: {},
	sentimentComparisonMetric:{},
	reactionComparisonMetric:{},
	keywordComparisonMetric: {},
	selectedMonitors: []
});

const getMonitorUuid = () => {
	return router.app.$route.params.monitor_uuid;
};

export default{
	namespaced: true,

	state:{
		//suggestedMax to compare monitor scale
		sentimentGraphSuggestedMax: 0,
		totalCategoriesGroupSuggestedMax:0,
		mentionComparisonMetric: {},
		sentimentComparisonMetric:{},
		reactionComparisonMetric:{},
		keywordComparisonMetric: {},
		selectedMonitors:[],
		comparisonReady: false,
		activeSection: 0 //action section value for scrolling
	},

	actions:{
		fetchMentionComparisonMetric({commit}, data) {
			return httpClient.post('/elastic/monitor/comparison/mention', data)
				.then(({data:{mentions}}) => {
					commit("setMentionComparisonMetric", mentions);
				});
		},

		fetchSentimentComparisonMetric({commit}, data){
			return httpClient.post('/elastic/monitor/comparison/sentiment',data)
				.then(({data:{sentiments}}) => {
					commit("setSentimentComparisonMetric", sentiments);
				});
		},

		fetchReactionComparisonMetric({commit}, data){
			return httpClient.post('/elastic/monitor/comparison/reaction', data)
				.then(({data:{reactions}}) => {
					commit("setReactionComparisonMetric", reactions);
				});
		},

		fetchKeywordsComparisonMetric({commit}, data) {
			return httpClient.post('/elastic/monitor/comparison/monitors', data)
				.then(({data}) => {
					commit("setKeywordComparisonMetric", data);
				});
		}
	},

	mutations:{
		setSentimentGraphSuggestedMax(state, val){
			state.sentimentGraphSuggestedMax = val;
		},

		setTotalCategoriesGroupSuggestedMax(state, val){
			state.totalCategoriesGroupSuggestedMax = val;
		},

		setDefaultState(state){
			Object.assign(state, resetDefaultState());
		},

		setMentionComparisonMetric(state, data){
			state.mentionComparisonMetric = data;
		},

		setSentimentComparisonMetric(state, data){
			state.sentimentComparisonMetric = data
		},

		setReactionComparisonMetric(state, data){
			state.reactionComparisonMetric = data;
		},

		setKeywordComparisonMetric(state, data){
			state.keywordComparisonMetric = data
		},

		setSelectedMonitors(state, data){
			state.selectedMonitors = data;
		},

		setComparisonReady(state, status){
			state.comparisonReady = status
		},

		setActiveSection(state, value){
			state.activeSection = value;
		}
	},

	getters: {
		monitorSentiments(state) {
			// order compare monitor sentiments
			let compareMonitorSentiments = Object.entries(state.sentimentComparisonMetric) || [];
			if (compareMonitorSentiments.length > 1) {
				let index = findIndex(compareMonitorSentiments, val => val[0] === getMonitorUuid());
				let monitor = compareMonitorSentiments.splice(index, 1);
				compareMonitorSentiments.unshift(...monitor);
			}
			return compareMonitorSentiments;
		},

		monitorReactions(state) {
			// order compare monitor reactions
			let compareMonitorReactions = Object.entries(state.reactionComparisonMetric) || [];
			if (compareMonitorReactions.length > 1) {
				let index = findIndex(compareMonitorReactions, val => val[0] === getMonitorUuid());
				let monitor = compareMonitorReactions.splice(index, 1);
				compareMonitorReactions.unshift(...monitor);
			}
			return compareMonitorReactions;
		},

		monitorKeywords(state) {
			//order compare monitor keywords
			let compareMonitorKeywords = Object.entries(state.keywordComparisonMetric);
			if (compareMonitorKeywords.length > 1) {
				let index = findIndex(compareMonitorKeywords, val => val[0] === getMonitorUuid());
				let monitor = compareMonitorKeywords.splice(index, 1);
				compareMonitorKeywords.unshift(...monitor);
			}
			return compareMonitorKeywords;
		},
	}
}
